var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('cargo-edit-data',{attrs:{"cargo":_vm.model,"id":_vm.id,"companyId":_vm.companyId,"modal":false,"modelstate":_vm.modelstate,"permission":_vm.permissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }